"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The result yielded during a recursive loop.
 * @export
 * @class RecursionResult
 * @template K
 * @template V
 * @template O
 */
var RecursionResult = (function () {
    function RecursionResult(_value, _key, _path, _parent, _previous) {
        this._value = _value;
        this._key = _key;
        this._path = _path;
        this._parent = _parent;
        this._previous = _previous;
    }
    Object.defineProperty(RecursionResult.prototype, "value", {
        /**
         * The value yielded.
         * @readonly
         * @type {V}
         */
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecursionResult.prototype, "key", {
        /**
         * The key used to access the value yielded
         * @readonly
         * @type {K}
         */
        get: function () {
            return this._key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecursionResult.prototype, "path", {
        /**
         * The path string used to access the yielded value from the root data object.
         * @readonly
         * @type {string}
         */
        get: function () {
            return this._path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecursionResult.prototype, "parent", {
        /**
         * The parent object of the value yielded.
         * @readonly
         * @type {(O | null)}
         */
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecursionResult.prototype, "previous", {
        /**
         * The previous yielded result. This may or may not be the parent value.
         * @readonly
         * @type {(RecursionResult<K, V, O> | null)}
         */
        get: function () {
            return this._previous;
        },
        enumerable: true,
        configurable: true
    });
    return RecursionResult;
}());
exports.RecursionResult = RecursionResult;
//# sourceMappingURL=RecursionResult.js.map